import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7960e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Ops ")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Alterar dados")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Fechar")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Formas de Pagamento ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/cartao.svg"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Cartão de Crédito ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Número do cartão ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Validade (MM/AAAA)")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("CVV")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Nome do Titular")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Salvar Cartão", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" para compras futuras ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Continuar")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode()
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Confirme o seu pedido ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/entrega.svg"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo-endereco-entrega" }, "Endereço de entrega ", -1))
const _hoisted_33 = { class: "endereco-entrega-rua" }
const _hoisted_34 = { class: "endereco-entrega-bairro" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "previsao" }, "Previsão", -1))
const _hoisted_36 = { class: "previsao" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/retirada.svg"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo-endereco-entrega" }, "Endereço de retirada ", -1))
const _hoisted_39 = { class: "endereco-entrega" }
const _hoisted_40 = { class: "endereco-entrega-rua" }
const _hoisted_41 = { class: "endereco-entrega-bairro" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "previsao" }, "Previsão", -1))
const _hoisted_43 = { class: "previsao" }
const _hoisted_44 = { class: "pagamento-titulo" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Confirmar pedido ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Voltar")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Confirmação ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Loja responsável pelo seu pedido ")
const _hoisted_49 = { class: "subtitulo-loja" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Subtotal")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Taxa de entrega")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Total")
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Selecione a sua forma de pagamento ")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("Voltar")
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        "backdrop-dismiss": true,
        canDismiss: true,
        "is-open": _ctx.isOpenRetorno,
        "initial-breakpoint": 0.50,
        breakpoints: [0, 0.25, 0.5, 0.75]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding font-suls" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "ion-text-center b2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "b2",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmOrder())),
                        color: "danger",
                        shape: "round"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isEnviando)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Confirmar e fazer pedido"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                _createVNode(_component_ion_spinner, { name: "circular" })
                              ]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.alterarDados())),
                        color: "danger",
                        fill: "#fff",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_modal, { "is-open": _ctx.isOpenRef }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "dark",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOpen(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconFechar }, null, 8, ["icon"]),
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center font-poppins-extra font-25",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enderecos.formaspagamento.formas, (forma, index) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      size: "12",
                      onClick: ($event: any) => (_ctx.setPayment(forma)),
                      key: 'c'+index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          color: "medium",
                          expand: "block",
                          size: "large",
                          fill: "outline"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              alt: "favourite",
                              src: '/assets/img/'+forma.img,
                              class: "buttom-img"
                            }, null, 8, ["src"]),
                            _createTextVNode(_toDisplayString(forma.nome), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.isOpenCard,
        onDidDismiss: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isOpenCard=false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SafeArea, {
            onOnBack: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpenCard=false)),
            data: {'cart': false}
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "ion-text-center font-montserrat layout_blue font-25"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_radio_group, {
                        modelValue: _ctx.enderecos.cartoes.escolhido,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.enderecos.cartoes.escolhido) = $event)),
                        value: _ctx.enderecos.cartoes.escolhido
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enderecos.cartoes.salvos, (opcao, index) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              disabled: _ctx.loading,
                              class: _normalizeClass({ 'pagamento-selecionado': _ctx.enderecos.cartoes.escolhido == opcao.uuid, 'pagamento-naoselecionado': _ctx.enderecos.cartoes.escolhido != opcao.uuid}),
                              key: 'c_pag'+index,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                (opcao.uuid!='new')
                                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.deleteCardToken(opcao)),
                                      slot: "start",
                                      size: "medium",
                                      icon: _ctx.iconRemove
                                    }, null, 8, ["onClick", "icon"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_ion_icon, {
                                  onClick: ($event: any) => {_ctx.setSaveCardToken(opcao);},
                                  slot: "start",
                                  size: "large",
                                  src: '/assets/img/'+opcao.brand+ '-icon.svg'
                                }, null, 8, ["onClick", "src"]),
                                _createVNode(_component_ion_label, {
                                  onClick: ($event: any) => {_ctx.setSaveCardToken(opcao);},
                                  class: _normalizeClass(opcao.uuid!='new'?'ion-text-end':'')
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(opcao.mask_number), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "class"]),
                                _createVNode(_component_ion_radio, {
                                  onClick: ($event: any) => {_ctx.setSaveCardToken(opcao);},
                                  slot: "end",
                                  color: "jauservelayoutalter",
                                  value: opcao.uuid
                                }, null, 8, ["onClick", "value"])
                              ]),
                              _: 2
                            }, 1032, ["disabled", "class"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.enderecos.cartoes.new)
                ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _hoisted_10,
                          _createElementVNode("img", {
                            height: "30",
                            alt: "favourite",
                            src: '/assets/img/' + _ctx.getCardType + '-icon.svg'
                          }, null, 8, _hoisted_11),
                          _hoisted_12,
                          _hoisted_13
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        size: "12",
                        class: "font-montserrat"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            placeholder: "Número do cartão",
                            class: "input-cadastro-cartao",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.enderecos.formaspagamento.card.number) = $event)),
                            onMaska: _cache[6] || (_cache[6] = ($event: any) => (_ctx.enderecos.formaspagamento.card.number_v = $event.target.dataset.maskRawValue))
                          }, null, 544), [
                            [_vModelText, _ctx.enderecos.formaspagamento.card.number],
                            [_directive_maska, ['#### #### #### ####', '#### #### #### ####']]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        size: "6",
                        class: "font-montserrat"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        size: "6",
                        class: "font-montserrat"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "6" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            placeholder: "MM/AAAA",
                            class: "input-cadastro-cartao",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.enderecos.formaspagamento.card.validade) = $event)),
                            onMaska: _cache[8] || (_cache[8] = ($event: any) => (_ctx.enderecos.formaspagamento.card.validade_v= $event.target.dataset.maskRawValue))
                          }, null, 544), [
                            [_vModelText, _ctx.enderecos.formaspagamento.card.validade],
                            [_directive_maska, ['##/####', '##/####']]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-25",
                        size: "6"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            placeholder: "CVV",
                            class: "input-cadastro-cartao",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.enderecos.formaspagamento.card.cvv) = $event)),
                            onMaska: _cache[10] || (_cache[10] = ($event: any) => (_ctx.enderecos.formaspagamento.card.cvv_v = $event.target.dataset.maskRawValue))
                          }, null, 544), [
                            [_vModelText, _ctx.enderecos.formaspagamento.card.cvv],
                            [_directive_maska, ['###', '###']]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        size: "12",
                        class: "font-montserrat"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-25",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "Nome do titular",
                            class: "input-cadastro-cartao",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.enderecos.formaspagamento.card.nome) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.enderecos.formaspagamento.card.nome]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-end font-montserrat font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { size: "2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_toggle, {
                                    modelValue: _ctx.enderecos.formaspagamento.card.save,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.enderecos.formaspagamento.card.save) = $event)),
                                    checked: _ctx.enderecos.formaspagamento.card.save
                                  }, null, 8, ["modelValue", "checked"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-start font-montserrat font-15",
                                size: "9"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_18,
                                  _hoisted_19
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _hoisted_20
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21,
                      _hoisted_22,
                      (!_ctx.isGetToken)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getCardToken())),
                            size: "large",
                            expand: "block",
                            color: "jauservelayoutalter",
                            shape: "jau"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_ion_button, {
                            key: 1,
                            size: "large",
                            color: "danger",
                            shape: "round"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_spinner, { name: "circular" })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isOpenCard=false)),
                        size: "large",
                        expand: "block",
                        color: "jauservelayoutciza6",
                        shape: "jau"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("p", {
                style: _normalizeStyle({ 'background': 'url('+_ctx.finger_print_get + ')' })
              }, null, 4),
              _hoisted_28,
              _createElementVNode("img", {
                src: _ctx.finger_print_get,
                alt: ""
              }, null, 8, _hoisted_29)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        "backdrop-dismiss": true,
        onDidDismiss: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isOpenConfirmSend=false)),
        canDismiss: true,
        "is-open": _ctx.isOpenConfirmSend,
        "initial-breakpoint": 0.80,
        breakpoints: [0, 0.80]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding font-suls" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "ion-text-center font-montserrat layout_blue font-25"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      (_ctx.isDelivery)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 0,
                            class: "ion-align-items-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { size: "2" }, {
                                default: _withCtx(() => [
                                  _hoisted_31
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, { size: "10" }, {
                                default: _withCtx(() => [
                                  _hoisted_32,
                                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.enderecos.escolhido.address1) + "-" + _toDisplayString(_ctx.enderecos.escolhido.c_addressNumber), 1),
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.enderecos.escolhido.address2) + " " + _toDisplayString(_ctx.enderecos.escolhido.c_neighborhood) + " - " + _toDisplayString(_ctx.enderecos.escolhido.city) + " - " + _toDisplayString(_ctx.enderecos.escolhido.state_code), 1),
                                  _hoisted_35,
                                  _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.enderecos.disponibilidades.selecionado.descricao), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isDelivery)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 1,
                            class: "ion-align-items-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { size: "2" }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, { size: "10" }, {
                                default: _withCtx(() => [
                                  _hoisted_38,
                                  _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.currentLocation.loja) + " " + _toDisplayString(_ctx.currentLocation.subnome_loja), 1),
                                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.currentLocation.end_loja), 1),
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.currentLocation.bairro_loja) + " - " + _toDisplayString(_ctx.currentLocation.cidade_loja) + " - SP ", 1),
                                  _hoisted_42,
                                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.enderecos.disponibilidades.selecionado.descricao), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "ion-text-center b2"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "pagamento-selecionado" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                size: "large",
                                src: '/assets/img/'+_ctx.enderecos.formaspagamento.escolhida.img
                              }, null, 8, ["src"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "10" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.enderecos.formaspagamento.escolhida.descricao), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "ion-text-center"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isEnviando)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.confirmOrder())),
                            size: "large",
                            color: "jauservelayoutalter",
                            shape: "jau",
                            expand: "block"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_45
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_ion_button, {
                            key: 1,
                            color: "jauservelayoutalter",
                            shape: "round"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_spinner, { name: "circular" })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  (!_ctx.isEnviando)
                    ? (_openBlock(), _createBlock(_component_ion_col, {
                        key: 0,
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.alterarDados())),
                            color: "jauservelayoutciza6",
                            size: "large",
                            shape: "round",
                            expand: "block"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_46
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[19] || (_cache[19] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, { class: "ion-align-items-center ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat font-25 layout_blue"
              }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "font-montserrat-bold layout_blue font-15"
              }, {
                default: _withCtx(() => [
                  _hoisted_48
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "12",
                class: "font-montserrat-bold titulo-loja"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Jaú Serve " + _toDisplayString(_ctx.currentLocation.loja) + " - ", 1),
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.currentLocation.subnome_loja) + " " + _toDisplayString(_ctx.currentLocation.bairro_loja), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "12" })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "titulos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_50
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_note, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$cart.currencyUSD(_ctx.cartTotal)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_51
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_note, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$cart.currencyUSD(_ctx.cartDelivery.taxa)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_52
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_note, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$cart.currencyUSD(_ctx.cartTotal+_ctx.cartDelivery.taxa)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _hoisted_53
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "12",
                class: "titulos"
              }, {
                default: _withCtx(() => [
                  _hoisted_54
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_radio_group, {
            modelValue: _ctx.enderecos.formaspagamento.escolhida,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.enderecos.formaspagamento.escolhida) = $event)),
            value: _ctx.enderecos.formaspagamento.escolhida
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enderecos.formaspagamento.formas, (opcao, index) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  disabled: _ctx.loading,
                  onClick: ($event: any) => (_ctx.setPayment(opcao)),
                  class: _normalizeClass({ 'pagamento-selecionado': _ctx.enderecos.formaspagamento.escolhida == opcao, 'pagamento-naoselecionado': _ctx.enderecos.formaspagamento.escolhida != opcao}),
                  key: 'c'+opcao.date,
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          size: "large",
                          src: '/assets/img/'+opcao.img
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_col, { size: "10" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(opcao.descricao), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_radio, {
                      slot: "end",
                      color: "jauservelayoutalter",
                      value: opcao
                    }, null, 8, ["value"])
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick", "class"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "value"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    class: "ion-button",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.voltar())),
                    size: "large",
                    shape: "jau",
                    expand: "block",
                    color: "jauservelayoutciza6"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_55
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "2",
                class: "ion-text-center"
              }),
              _createVNode(_component_ion_col, {
                size: "5",
                class: "ion-text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    class: "ion-button",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showConfirmation())),
                    size: "large",
                    shape: "jau",
                    expand: "block",
                    disabled: _ctx.loading,
                    color: "jauservelayoutalter"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                            _createVNode(_component_ion_spinner, { name: "circular" })
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_57, "Finalizar Pedido")),
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: _ctx.chevronForward
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}